module.exports = "https://r.zoocdn.com/_next/static/images/selling-large-c799dad2ff2ed33a4409f9415a0a8d56.svg";